import httpClient from "../../../../api/httpClient";
// eslint-disable-next-line no-unused-vars
import { convertDateToUTC, convertTimeToUTC } from "../utils/formatters"; // Must convert to UTC before sending, don't delete
import { API_BASE_URL } from "./contractApi.js";

export const accessorialApi = {

  getAccessorials: (officeCode) =>
    httpClient.get(`${API_BASE_URL}/organizations/${officeCode}/accessorials/mappings`),

  getAccessorialsByCode: (officeCode, accessorialCode) =>
    httpClient.get(`${API_BASE_URL}/organizations/${officeCode}/accessorials/mappings/${accessorialCode}`),

};
